import React from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../Services/Store";
import "./RoleManagement.css";
import StateCityManager from "./StateCityManager";

const StateCityPage: React.FC = () => {
  const navigate = useNavigate();
  const accessList = useSelector((state: RootState) => state.auth.access || []);
  const hasRbac = accessList.find((item) => item.code === "rba_control")?.read === true;

  return (
    <div className="role-container">
      <div className="mgmt-tabs">
        {hasRbac && (
          <>
            <button type="button" className="mgmt-tab" onClick={() => navigate("/role-management")}>
              <span className="mgmt-tab-icon">🗂️</span> Role Management
            </button>
            <button type="button" className="mgmt-tab" onClick={() => navigate("/access-management")}>
              <span className="mgmt-tab-icon">🔑</span> Access Management
            </button>
          </>
        )}
        <button type="button" className="mgmt-tab active">
          <span className="mgmt-tab-icon">📍</span> State & City
        </button>
      </div>

      <h2 className="panel-title access-title">State & City Management</h2>
      <p className="panel-desc">
        Manage countries, then add states and cities under the selected country. Address forms only show cities that belong to that state.
      </p>

      <div className="role-table-container state-city-body">
        <StateCityManager />
      </div>
    </div>
  );
};

export default StateCityPage;
